<template>
  <div class='payment'>
    <div class="mt-4">
      <strong>
        Escolha abaixo a opção desejada quanto à forma de pagamento:
      </strong>

      <div class='w-100 d-flex flex-wrap justify-content-between my-4'>
        <button
          @click="setMethod('bank_slip')"
          :class="payment.method === 'bank_slip' ? 'hits_select ':'hits_no_select'"
        >
          <span>PIX</span>
        </button>

        <button
          @click="setMethod('credit_card')"
          :class="payment.method === 'credit_card' ? 'hits_select ':'hits_no_select'"
        >
          <span>Cartão de crédito</span>
        </button>
      </div>

      <div v-if="payment.method === 'bank_slip'" class="hits_description">
        <strong >
          Pagamento via PIX:
        </strong>
        <span>
                    O acesso à plataforma HO Fácil Web é liberado automaticamente em até 30 minutos após a confirmação do pagamento.
                  </span>
      </div>

      <div v-if="payment.method === 'credit_card'" class="hits_description">
                  <span>
                    O acesso à plataforma HO Fácil Web é liberado automaticamente assim que o pagamento
                    é aprovado pela operadora do cartão. Esse processo pode levar até <strong>15 minutos</strong>.
                  </span>
      </div>
    </div>

    <div
      class="credit_card-form"
      v-if="payment.method === 'credit_card'"
    >
      <div class="rows_2">
        <div class="rows_2_div">
          <label>Nome impresso no cartão</label>
          <base-input-text
            v-model='v$.payment.data.full_name.$model'
            type='text'
            block
            placeholder='Nome impresso no cartão'
            :error='getError(v$.payment.data.full_name)'
          />
        </div>

        <div class="rows_2_div">
          <label>Número</label>
          <base-input-text
            v-model='v$.payment.data.number.$model'
            type='text'
            block
            placeholder='0000 0000 0000 0000'
            v-mask="'#### #### #### ####'"
            :error='getError(v$.payment.data.number)'
          />
        </div>
      </div>

      <div class='validity mt-2'>
        <div>
          <label>Mês</label>
          <base-input-select
            v-model='v$.payment.data.month.$model'
            type='text'
            placeholder='Mês'
            block
            :options='monthOptions'
          />
        </div>

        <div>
          <label>Ano</label>
          <base-input-select
            v-model='v$.payment.data.year.$model'
            type='text'
            placeholder='Ano'
            class="w-100"
            :options='yearOptions()'
          />
        </div>

        <div class="d-flex">
          <div>
            <label>Código de Segurança</label>
            <base-input-text
              v-model='v$.payment.data.cvv.$model'
              type='text'
              placeholder='000'
              v-mask="['###', '####', '#####']"
            >
              <template #icon-label>
                <base-tooltip>
                  <template #body>
                    <i class='fa fa-info-circle' />
                  </template>
                  <template v-slot:message>
                    O código de segurança fica impresso no verso do cartão de crédito.
                  </template>
                </base-tooltip>
              </template>
            </base-input-text>
          </div>
          <div class='cc-back'>
            <img src='../../../assets/images/cc-icon.png' />
          </div>
        </div>
      </div>

      <div class='mt-2'>
        <label>Quatidade de parcelas</label>
        <b-form-select

          style='height: 50px'
          v-model='v$.payment.data.installments.$model'
          type='text'
          :options='installmentsOptions'
          :error='getError(v$.payment.data.installments)'
          _key='value'
          _value='text'>
        </b-form-select>
      </div>
    </div>

    <div class="mt-2">
      <base-alert2
        v-if="alert.open"
        class="alert"
        :type="alert.type"
        :message="alert.message"
        @close="alert.open = false"
      />
    </div>
    <div class='buttons w-100 d-flex justify-content-end mt-2'>
      <base-button
        danger
        class=' w-50'
        @click="back()"
      >
        Voltar
      </base-button>
      <b-overlay
        :show='loading'
        rounded
        opacity='0.6'
        spinner-small
        spinner-variant='primary'
        class='d-inline-block w-50'
      >
        <base-button
          :disabled='loading || !canNext()'
          @click='handleSubmitPaymentMethod' class='w-100'>
          <span class='ml-2'>Próximo</span>
        </base-button>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import useVuelidate from '@vuelidate/core'
import { required, minLength, maxLength } from '@/utils/validators'
import { getYear } from 'date-fns'
import { mask } from 'vue-the-mask'
import IUGU from '@/services/iugu'

export default {
  name: 'Payment',
  components: {},
  directives: { mask },
  setup() {
    return { v$: useVuelidate() }
  },
  computed: {
    ...mapGetters('checkout2', {
      payment: 'getPayment',
      isCreditCard: 'getIsCreditCard',
      alert: 'getAlertDetails'
    })
  },
  data() {
    return {
      token: '',
      chargeMadeSuccessfully: false,
      tentativa: 0,
      loading: false,
      previousComponent: 'BillingDataAccess',
      nextComponent: 'Confirmation',
      methodsOptions: [
        { key: 'credit_card', value: 'Cartão de crédito' },
        { key: 'bank_slip', value: 'PIX' }
      ],
      monthOptions: [
        { _id: '1', value: '1 - Janeiro' },
        { _id: '2', value: '2 - Fevereiro' },
        { _id: '3', value: '3 - Março' },
        { _id: '4', value: '4 - Abril' },
        { _id: '5', value: '5 - Maio' },
        { _id: '6', value: '6 - Junho' },
        { _id: '7', value: '7 - Julho' },
        { _id: '8', value: '8 - Agosto' },
        { _id: '9', value: '9 - Setembro' },
        { _id: '10', value: '10 - Outubro' },
        { _id: '11', value: '11 - Novembro' },
        { _id: '12', value: '12 - Dezembro' }
      ],
      installmentsOptions: [
        { value: 1, text: '1x sem juros' },
        { value: 2, text: '2x sem juros' },
        { value: 3, text: '3x sem juros' },
        { value: 4, text: '4x com juros' },
        { value: 5, text: '5x com juros' },
        { value: 6, text: '6x com juros' },
        { value: 7, text: '7x com juros' },
        { value: 8, text: '8x com juros' },
        { value: 9, text: '9x com juros' },
        { value: 10, text: '10x com juros' },
        { value: 11, text: '11x com juros' },
        { value: 12, text: '12x com juros' }
      ]
    }
  },
  created() {
    const breadcrumb = {
      tab: '',
      page: 'Comprar acessos',
      subPage: {
        name: 'Comprar acessos',
        active: false
      },
      tabs: [
        {
          name: 'Forma de pagamento',
          active: true
        }
      ]
    }
    this.setBreadcrumb(breadcrumb)
  },
  async mounted() {
    IUGU.setup()
    this.payment.method = 'credit_card'
  },
  validations() {
    return {
      payment: {
        method: { required },
        data: {
          full_name: { required },
          first_name: { },
          last_name: { },
          number: { required, minLength: minLength(17) },
          month: { required },
          year: { required },
          cvv: { required, minLength: minLength(3), maxLength: maxLength(5) },
          installments: {}
        }
      }
    }
  },
  methods: {
    ...mapActions('creditCard', {
      handleCreatePaymentMethods: 'handleCreatePaymentMethods'
    }),
    ...mapActions('checkout2', {
      handleGetTokenCreditCard: 'handleGetTokenCreditCard',
      handleSetAlertDetails: 'handleSetAlertDetails',
      handleSetMethod: 'handleSetMethod',
    }),
    ...mapActions('breadcrumb', {
      setBreadcrumb: 'setBreadcrumb'
    }),
    ...mapActions('checkoutAccess', {
      handleSetToken: 'handleSetToken',
      handleSubmitCheckout: 'handleSubmitCheckout'
    }),
    ...mapActions('breadcrumb', {
      setBreadcrumb: 'setBreadcrumb',
    }),
    async setMethod(method){
      await this.handleSetMethod(method)
      this.alert.open = false
    },
    back(){
      this.$emit('back-step')
      this.$emit('set-component', this.previousComponent)
    },
    async handleSubmitPaymentMethod() {
      try {
        this.loading = true
        if(this.payment.method === 'credit_card') {
          const response = await this.handleGetTokenCreditCard()
          if (response.error || response.token.error) {
            await this.handleSetAlertDetails({
              open: true,
              message: response.error ? response.error : response.token.error,
              type: 'danger',
            })
            const payload = {
              sent: '-',
              status: 'failed',
              responseError: response ? response : '-',
              user: this.user ? this.user : '-',
            }
            await this.$api
              .post('users/sendErrorTokenCardMail', payload)
              .then((res) => { })
              .catch(() => {})
            this.loading = false;
            return
          }
          await this.handleSetToken(response.token)
        }
        this.$emit('next-step')
        this.$emit('set-component', this.nextComponent)

      } catch (e) {

      } finally {

      }
    },
    async submit() {
      try {
        this.loading = true
        const { sucess, errors } = await this.handleCreatePaymentMethods({ tokenCard: this.token })
        if (errors) {
          this.$bvToast.toast(errors, {
            title: 'Aviso',
            variant: 'danger',
            toaster: 'b-toaster-top-center',
            autoHideDelay: 5000
          })
          return
        }

        this.$bvToast.toast('Alteração efetuada com sucesso!', {
          title: 'Aviso',
          variant: 'success',
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })

        setTimeout(() => {
          this.$emit('close')
        }, 2000)
      } catch (error) {
      } finally {
        this.loading = false
      }
    },
    canNext() {
      if (!this.payment.method) return false

      if (this.isCreditCard) {
        if (this.v$.payment.data.$invalid) return false
      }

      return true
    },
    yearOptions() {
      const now = new Date()
      const currentYear = getYear(now)
      const yearOptions = []
      const CURRENT_YEAR_ADD_15_YEARS = currentYear + 15

      for (let year = currentYear; year <= CURRENT_YEAR_ADD_15_YEARS; year += 1) {
        yearOptions.push({
          _id: year,
          value: year
        })
      }
      return yearOptions
    },
    getError(value) {
      if (value.$errors.length > 0) {
        return value.$errors[0].$message
      }
      return ''
    }
  },
  watch: {}
}
</script>

<style lang='scss' scoped>
.loading-spinner {
  width: 2.5rem;
  height: 2.5rem;
}

.payment {
  display: flex;
  flex-direction: column;
  gap: 16px;

  .credit_card-form {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .group, .validity {
      display: grid;
      gap: 16px;
    }

    .group {
      grid-template-columns: 1fr 1fr;
      @media only screen and (max-width: 720px) {
        grid-template-columns: 1fr;
      }
    }

    label {
      font-size: 15px;
      font-weight: 700;
    }

    .validity {
      grid-template-columns: 1fr 1fr 1fr;
      .cc-back {
        display: flex;
        align-items: flex-end;
        // justify-content: center;
        padding: 5px;

        img {
          width: 40px;
          height: auto;
        }
      }
    }
  }

  .promotion {
    a {
      color: var(--blue);

      &:hover {
        text-decoration: underline;
      }
    }

    .check-code {
      display: flex;
      align-items: flex-end;
      gap: 8px;
    }
  }

  .buttons {
    margin-top: 20px;
    display: flex;
    gap: 5px;
  }

  .hits_select {
    text-align: center;
    border: 1px solid #04A8F3;
    padding: 5px;
    border-radius: 6px;
    background: #CBD63E;
    color: #262626;
    font-weight: 700;
    width: 49%;
    font-size: 15px;
  }

  .hits_no_select {
    border: 1px solid #04A8F3;
    padding: 5px;
    border-radius: 6px;
    background: transparent;
    color: #04A8F3;
    font-weight: 700;
    width: 49%;
    font-size: 15px;
  }

  .rows_2 {
    display: flex;
    justify-content: space-between;
    align-content: center;
    width: 100%;
    flex-wrap: wrap;

    .rows_2_div {
      width: 49%;
      min-width: 300px;
    }
  }
}
</style>
